import { render, staticRenderFns } from "./VQSelect.vue?vue&type=template&id=3a5e79d9&scoped=true&"
import script from "./VQSelect.vue?vue&type=script&lang=js&"
export * from "./VQSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e79d9",
  null
  
)

export default component.exports